module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAMAAABhq6zVAAAAM1BMVEX///////////////////////////9HcEz///////////////////////////////////85yRS0AAAAEHRSTlOBdlw4fBpEAEC/uaXLSOHRcQDknQAAAEVJREFUeAFlzUkOgDAMQ1EzO4y+/2kpIQFE/6LSkyoH06c/SJNAXoAi3uA2lhcONPvRWsAWqX/QrfOQ3wT4YAFzDdXRtxN3JQTVjm5dCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/carema.png
// module id = y+vj
// module chunks = 1